import React from 'react';
import AppRoutes from '../routes';
import Footer from '../components/asteria/footer';
import Header from '../components/asteria/header';
import HomePage from '../pages/asteria/home_page';
import AboutPage from '../pages/asteria/about_page';
import ContactPage from '../pages/asteria/contact_page';
import PortfolioPage from '../pages/asteria/portfolio_page';

export default function AsteriaTemplate(props) {
    return (
        <React.Fragment>
            <Header />
            <AppRoutes
                homePage={HomePage}
                contactPage={ContactPage}
                aboutPage={AboutPage}
                portfolioPage={PortfolioPage}
            />
            <Footer />
        </React.Fragment>
    )
}
